import L from "leaflet";
import { Marker } from "react-leaflet";
import { Weight } from "../../../services/RuteplanAPI";
import vektIconResource from "../../../assets/vekt.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const vektIcon = L.icon({
    iconUrl: vektIconResource,
    iconRetinaUrl: vektIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface IVektMarkersProps {
    vektbegrensninger: Array<Weight>;
}

export default function VektMarkers (props: IVektMarkersProps) {
    const {setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();
    const { vektbegrensninger } = props;

    return (
        <>
            {vektbegrensninger && vektbegrensninger.map((vektbegrensning: Weight, index: number) => {
                return (
                    <Marker key={vektbegrensning.maxWeight + index}
                    position={[vektbegrensning.location!.y, vektbegrensning.location!.x]}
                    icon={vektIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(vektbegrensning);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}